import { render, staticRenderFns } from "./HomeDj.vue?vue&type=template&id=7afcbcf2&scoped=true&"
import script from "./HomeDj.vue?vue&type=script&lang=js&"
export * from "./HomeDj.vue?vue&type=script&lang=js&"
import style0 from "./HomeDj.vue?vue&type=style&index=0&id=7afcbcf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afcbcf2",
  null
  
)

export default component.exports